import type { JSX, ReactNode } from 'react';

type Tone = 'neutral' | 'amber' | 'emerald' | 'red' | 'sky' | 'slate';

const TONES: Record<Tone, string> = {
  neutral: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200',
  amber: 'bg-amber-100 text-amber-800 dark:bg-amber-950/50 dark:text-amber-300',
  emerald: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-950/50 dark:text-emerald-300',
  red: 'bg-red-100 text-red-800 dark:bg-red-950/50 dark:text-red-300',
  sky: 'bg-sky-100 text-sky-800 dark:bg-sky-950/50 dark:text-sky-300',
  slate: 'bg-slate-900 text-slate-50 dark:bg-slate-100 dark:text-slate-900',
};

export function Badge({
  children,
  tone = 'neutral',
}: {
  children: ReactNode;
  tone?: Tone;
}): JSX.Element {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ${TONES[tone]}`}
    >
      {children}
    </span>
  );
}

export function planTone(state: string): Tone {
  switch (state) {
    case 'active':
    case 'pro':
      return 'emerald';
    case 'trial':
      return 'sky';
    case 'grace':
      return 'amber';
    case 'expired':
      return 'red';
    default:
      return 'neutral';
  }
}

export function roleTone(role: string): Tone {
  switch (role) {
    case 'platform_owner':
      return 'slate';
    case 'business_admin':
      return 'sky';
    case 'business_user':
      return 'neutral';
    default:
      return 'neutral';
  }
}
